import { useCallback, useEffect, useMemo, useState } from "react";
import ErrorMessage from "./ErrorMessage";
import Hint from "./Hint";
import Label from "./Label";
import Select from "./Select";
import className from "classnames";
import {
  GOVGR_ERROR_INPUT,
  GOVGR_FIELD,
  GOVGR_FIELD__ERROR,
  GOVGR_SELECT,
} from "../../conf/styles/GovGrSelect";
import { CHOOSE_ONE_TEXT, FIELD_CANT_BE_EDITED_TEXT } from "./constants";

const SelectBoxComponent = ({
  field,
  form: { setFieldValue, setFieldTouched, touched, errors, values },
  ...props
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const defaultValueSelect = () => {
      if (values[field.name]?.id) return values[field.name]?.id;
      return -1;
    };
    setValue(defaultValueSelect());
  }, [field.name, values]);

  const onChange = useCallback(
    (e) => {
      const { value } = e.target;
      const optionSelected = props.options.filter(
        (selected) => selected.id === parseInt(value)
      );
      setValue(optionSelected[0]?.id);
      setFieldValue(field.name, optionSelected[0]);
    },
    [field.name, props.options, setFieldValue]
  );

  const checkErrorsAndTouchFields = useMemo(
    () => touched[field.name] && !!errors[field.name],

    [touched, errors, field.name]
  );

  // Checking for disabled message or hint on props and if not found fill them with predetermined values
  let disabledmessage = props.disabledmessage
    ? props.disabledmessage
    : FIELD_CANT_BE_EDITED_TEXT;
  let hint = props.hint ? props.hint : CHOOSE_ONE_TEXT;

  // Classes for Components based on if error is present or not
  let ComponentWrapperClass = className(GOVGR_FIELD, "flex", "flex-col", {
    [`${GOVGR_FIELD__ERROR}`]: checkErrorsAndTouchFields,
  });
  let selectComponentClass = className(GOVGR_SELECT, {
    [`${GOVGR_ERROR_INPUT}`]: checkErrorsAndTouchFields,
  });

  return (
    <div className={ComponentWrapperClass} {...props}>
      <Label disabled={props.disabled} label={props.label} />
      {checkErrorsAndTouchFields ? (
        <ErrorMessage errorMessage={errors[field.name]} />
      ) : (
        <Hint
          hint={props.disabled === true ? disabledmessage : hint}
          name={field.name}
        />
      )}

      <Select
        name={field.name}
        className={selectComponentClass}
        onChange={onChange}
        disabled={!!props.disabled}
        value={value}
        options={props.options}
        optionlabel={props.optionlabel}
        defaultOptionText={props.defaultOptionText}
        onBlur={() => setFieldTouched(field.name, true)}
      />
    </div>
  );
};

export default SelectBoxComponent;
